<Cell {header} {priority} type="checkbox" {colspan} {rowspan}>
    <div slot="header-data">
        <!-- Stop mouse click propagation on this element so
            that it doesnt double toggle the check box -->
        <div class="prom-cell__checkbox" on:click|stopPropagation>
            <Checkbox bind:checked label={text} small {disabled} {name} labelHidden on:change />
        </div>
    </div>
</Cell>

<script>
    import Cell from '../../Cell/v1/Cell.svelte';
    import Checkbox from '../../../inputs/Checkbox/v1/Checkbox.svelte';

    /** @type {string} */
    export let text = '';
    /** @type {boolean} */
    export let checked = false;
    /** @type {boolean} */
    export let header = false;
    /** @type {1|2|3} */
    export let priority = 1;
    /** @type {number} */
    export let colspan = 1;
    /** @type {number} */
    export let rowspan = 1;
    /** @type {boolean} */
    export let disabled = false;
    /** @type {string} */
    export let name = undefined;
</script>
